<template>
    <div id="customer_create_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="customercontactHeader" >Update Inventory</span>
                    <button type="submit" class="btn btn-tertiary pull-right" v-on:click.prevent="backPage" >
                        <i class="fp-back"></i>    Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content update-inventory">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="CustomerContactForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group mt-4">
                                        <label class="control-label" for="location">Stock Number:</label>
                                        <span class="label"> {{stock_no}}  </span>        
                                    </div>
                                    <div class="col form-group mt-4">
                                        <label class="control-label" for="location">Asset:</label>
                                        <span class="label"> {{manufacturer}} {{model}} </span>        
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-md-6 form-group">
                                        <div id="uploadForm" class="custom-upload-container ml-0" data-provides="fileupload">
                                            <label for="physicalFiles" class="fileupload-new btn btn-secondary"> <i class="fp-upload"></i>Upload</label>
                                            <label for="physicalFiles" class="fileupload-exists btn btn-secondary hide"> <i class="fp-upload"></i>Change</label>
                                            <input class="hide" type="file" id="physicalFiles" ref="Files" multiple accept="image/*" v-on:change="handleFilesUpload()"/>
                                        </div>
                                        <template v-for="(file, gkey) in insfile">
                                            <div class="file-container" :id="'fileDiv'+file.id" :key="gkey">
                                                <span class="fileupload-preview">{{ file.name }}</span>
                                                <a href="javascript:void(0)" :class="'close'" data-dismiss="fileupload" v-on:click="deleteFile(file.id,key,file.fullName)" style="float: right">
                                                    <i class="fp-delete"></i>
                                                </a>
                                            </div>
                                        </template>
                                        <span class="field-error">{{ Docerrors }}</span>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group">
                                        <template v-for="(images, fkey) in uploadedArr">
                                            <template v-for="(img, fkey) in images">
                                                <div :key="fkey" class="mb-3">
                                                    <figure class="effect-ming d-inline-block w-50">
                                                        <a href="javascript:void(0)">
                                                            <img :src="img.url" :alt="img.display_name"/>
                                                        </a>
                                                    </figure>
                                                    <div class="d-inline-block pull-right" v-on:click="deleteFile(img.id,key,img.file_name)" >
                                                        <i class="fp-close color-red cursor-pointer" aria-hidden="true" ></i>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="submitBtn" value="Search" class="btn btn-primary" v-on:click.prevent="submitUpdate" >
                                        <i class="fp-reload"></i>Update
                                    </button>
                                    <button type="submit" id="cancelBtn" value="Cancel" class="btn btn-tertiary" v-on:click.prevent="backPage" >
                                        <i class="fp-close"></i> Cancel
                                    </button>                                                
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';
export default {
  name: "AssetAvailability",
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: "Update Asset Inventory | " +process.env.COPYRIGHT_NAME
  },
  
  mixins:[commonMixins,contractMixins],
  data: () => ({
    options: {
        format: 'MM/DD/YYYY',
        useCurrent: true,
        minDate:new Date()
    },
    fromDate:"",
    fromDateError:"",
    toDate:"",
    toDateError:"",
    locationId: null,
    locationArr: [],
    assetTypeId: null,
    loading:"",
    insfile:[],
    vehicleTypeArr:[],
    permissions: [],
    cantAccessPage: "",
    Docerrors:'',
    assetId:0,
    basePath:'',
    stock_no:'',
    manufacturer:'',
    model:'',
    uploadedArr : [],
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if ( permissions[i].name == 'check_asset_availability' ) {
                        self.cantAccessPage = true;
                    }
                }
            }

        },
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        
        self.getPermissions();

        self.assetId = self.$route.params.id;
        // self.loadFieldData(['location','vehicleType']);
        
        self.getAssetInventoryData();

        var path =  process.env.ROOT_API;

        var imgPath = path.split('/');
        console.log(imgPath);

        self.basePath = imgPath[0]+'//'+imgPath[2];
  },
  methods: {
        getAssetInventoryData(){
            var self = this;

            $.ajax({
                    url: process.env.ROOT_API + "/asset-details/inventory",
                    type: "GET",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,
                    data: {
                        id: self.assetId,
                    },
                    success: function(data) {
                        self.loading = false;
                        // console.log(data.content[0]["id"]);
                        if (data.status == "success") {

                            self.stock_no  = data.content.stock_no;
                            self.manufacturer = data.content.manufacturer;
                            self.model = data.content.model;
                            if(data.content.local_url && data.content.local_url != ''){
                                self.uploadedArr.push(data.content.local_url);
                            }

                           /* var images = data.content.local_url;

                            if(images && images != ''){

                                // var img = images.split(',');

                                if(images[0]){
                                    var fileName = [];
                                    for( var i=0; i < images.length; i++){

                                        fileName = images[i].split('_');
                                        fileName['id'] = data.content.id;
                                        fileName['name'] = fileName[2];
                                        fileName['fullName'] = images[i];

                                        self.uploadedArr.push(fileName);
                                    }
                                }
                            }*/
                        
                            console.log(data.content);
                        }
                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        $("#extraChargeModal").modal("hide");
                        self.generateStatusCodeMessage(jqXHR,false,'get-asset-inventory-data')
                    }
                });

        },

        handleFilesUpload: function() {
            /*
              Get the uploaded files from the input.
          */
            var self = this;

            console.log(self.$refs.Files.files);
            var uploadedinsFiles = "";
            uploadedinsFiles = self.$refs.Files.files;
             console.log("in.....",uploadedinsFiles);

                for (var i = 0; i < uploadedinsFiles.length; i++) {
                     self.insfile.push(uploadedinsFiles[i]);
                }
                console.log(self.$refs.Files.value);
                self.$refs.Files.value = '';
                // console.log(self.$refs.$phyFiles[0]);
       
        },
        deleteFile: function(id,key,fullName) {
            var self = this;

            if (confirm('Are you sure that you want to remove file? ')) {

                self.submitBtn = false;
                console.log( self.$refs.Files);
                if(id == undefined){

                    this.insfile.splice(key,1)
                    self.$refs.Files.value = '';
                    self.Docerrors = '';
                }
                if(id != undefined){

                    self.deleteInventoryFile(id,fullName);
                    self.insfile.splice(key,1)
                    self.$refs.Files.value = '';
                }
            }
            
            return;
            
        },
        deleteInventoryFile(id,fullName){

            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/delete_inventory_file",
                type: "POST",
                crossDomain: true,
                
                data: {id:id,name:fullName},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function(data) {

                    self.loading = false;
                    self.insfile = [];
                    self.uploadedArr = [];
                    // self.insfile.splice(key,1)
                    // self.$refs.Files.value = '';
                    self.getAssetInventoryData();

                },
                error: function(jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'delete-asset-inventory-file')
                }
            });
        },

        submitUpdate() {

            var self = this;

            var formData = new FormData();

                var error = false;
                for (var i = 0; i < self.insfile.length; i++) {
                                
                                
                    let file = this.insfile[i];
                    if(!Array.isArray(file)){

                        if ( file.size > 5000000 ) {
                            self.Docerrors = 'File size should not be greater than 5 MB';
                            error = true;
                        }
                        if ( file.type == "image/jpeg" || file.type == "image/png" ) {
                        } else {
                            self.Docerrors = 'Only image files are allowed (.png / .jpeg)';
                            error = true;
                        }

                        if ( self.Docerrors == "" ) {
                            formData.append("files[]", file);
                        }
                    }
                    
                }
                formData.append("asset_id", self.assetId);

                if(error == false){
                    
                    $.ajax({
                        url: process.env.ROOT_API + "/update_inventory_data",
                        type: "POST",
                        crossDomain: true,
                        processData: false,
                        contentType: false,
                        data: formData,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function(data) {

                            self.loading = false;
                            self.$refs.Files.value = '';
                            self.$router.push("/asset-inventory/list");

                        },
                        error: function(jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'update-asset-inventory-data')
                        }
                    });
                }
                

        },
    backPage() {
      var self = this;
      self.$router.push("/asset-inventory/list");
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/asset/AssetInventoryUpdate.vue